import projectList from './projectList';
import projectUsers from './projectUsers';
import projectNavigation from './projectNavigation';
import remunerations from './remunerations';
import patients from './patient/patients';
import surveySaveBar from './patient/surveySaveBar';
import payments from './payments';
import actors from './actors';
import genericImport from './genericImport';
import exports from './exports';
import priceCode from './priceCode';
import projectDetails from './projectDetails';
import projectGroupProjects from './projectGroupProjects';
import undues from './undues';
import refunds from './refunds';

export default {
	projectGroupProjects,
	priceCode,
	projectDetails,
	projectList,
	projectUsers,
	patients,
	surveySaveBar,
	projectNavigation,
	remunerations,
	payments,
	actors,
	genericImport,
	exports,
	undues,
	refunds
};
